if (!customElements.get('cart-upsell')) {
  customElements.define(
    'cart-upsell',
    class extends HTMLElement {
      constructor() {
        super();

        this.slider = this.querySelector('.upsell-slider');
        this.slider_template = this.querySelector('#slider_template');

        const _this = this;
        setTimeout(function () {
          _this.data = Debutify.widgets['cart_upsell'];
          _this.cartItems = Debutify.cart.items;
          _this.init();
        }, 1000);
      }

      init() {
        this.getEligibleUpsell();
      }

      getEligibleUpsell() {
        let cartHandles = this.cartItems.map((item) => item.handle);

        let eligibleUpsell = this.data.specific.filter((item) => {
          return cartHandles.includes(item.product_trigger);
        });

        if (!eligibleUpsell.length) {
          this.upsellProduct = this.data.global;
        } else {
          this.upsellProduct = eligibleUpsell;
        }

        let slider = this.slider_template.innerHTML;
        let slides = '';
        this.upsellProduct.forEach((item) => {
          slides += item.card_html;
        });
        slider = Debutify.replaceVariables(slider, { slides: slides });
        this.slider.innerHTML = slider;
      }
    }
  );
}
